import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import classNames from 'classnames';

import { Box, Text, CenteredContainer } from '@nerdwallet/currency';
import WpEmbed from '@nerdwallet/react-wp-embed';
import classes from '@nerdwallet/base-styles/classes';
import appConfig from '@nerdwallet/app-config';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import { isInBuilder } from '../../lib/helpers';

import { stringInputSpec } from '../../lib/editing-configs';

const Calculator = ({ cffId, history }) => {
  const iframeUrl = `${appConfig.SITE_BASE_URL}/blog/cff/?form_id=${cffId}`;

  const defaultEditorOutput = () => {
    const url = get(history, 'location.pathname');
    if (isInBuilder(url)) {
      return (
        <CenteredContainer
          className={classNames([
            'calculator__default-output',
            'landing-page-standard__max-widths',
          ])}
        >
          <Box
            className={classNames([
              classes('padding-vertical-5'),
              classes('text-align-center'),
            ])}
          >
            <Text size="large" bold align="center">
              Enter a CFF ID to make a calculator appear
            </Text>
          </Box>
        </CenteredContainer>
      );
    }
    return null;
  };

  return !cffId ? (
    defaultEditorOutput()
  ) : (
    <CenteredContainer
      className={classNames([
        classes('padding-vertical-3'),
        'landing-page-standard__max-widths',
      ])}
    >
      <WpEmbed src={iframeUrl} />
    </CenteredContainer>
  );
};

Calculator.propTypes = {
  cffId: PropTypes.string,
  history: PropTypes.object,
};

Calculator.getEditingConfig = () => [
  stringInputSpec('cffId', 'Calculated Fields Form ID', {
    help: 'For a list of CFFs you can display on landing pages, login to Wordpress and navigate to Settings > Calculated Fields Form.',
  }),
];

export default compose(withRouter, connect())(Calculator);
